export default __webpack_public_path__ + "static/media/038-blender.03f5b285.svg";